<template>
  <Chart :options="chartOptions"></Chart>
</template>
<script setup>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting';
import { Chart } from 'highcharts-vue';
import coloraxisInit from "highcharts/modules/coloraxis";
import moreInit from "highcharts/highcharts-more";
import  heatmapInit from 'highcharts/modules/heatmap';
import dataInit from 'highcharts/modules/data';

exportingInit(Highcharts);
coloraxisInit(Highcharts);
moreInit(Highcharts);
heatmapInit(Highcharts);
dataInit(Highcharts)

const chartOptions = {        
    chart: {
        marginTop: 55,
        type: 'heatmap',
        plotBorderWidth: 1,
        height: '500px',
        zoomType: 'xy',
        style: {
            fontFamily: 'Montserrat'
        },

    },
    plotOptions: {
        
        states: {
        inactive: {
          opacity: 1
        },
        hover: {
          brightness: -0.2 // darken
        }
      }
    },
    title: {
        text: '<p style="font-size: 1.1rem; color: rgb(55, 65, 81); text-transform: uppercase; font-weight: 500; fill: rgb(55, 65, 81);">Paper alternatives</p>',

      },
      credits: {
        enabled: false
    },
 
    yAxis: {
        reversed: true,
        minPadding: 0,
        maxPadding: 0,
        scrollbar: {
            enabled: true,
            showFull: false
          },

        //tickWidth: 2,
        //tickColor: 'gray',
        //min: 1,
        title: null,
        labels: {
                x: -5,
                useHTML: false,
                rotation: 0,
                  style: {
                    color: '#374151',
                    fontSize: '12px',
                    fontWeight: 'normal',
                    fontFamily: 'Montserrat',
                  }
            },
        categories: ['Paper 1', 'Paper 2', 'Paper 3', 'Paper 4', 'Paper 5', 'Paper 6', 'Paper 7', 'Paper 8', 'Paper 9', 
                  'Paper 10', 'Paper 11', 'Paper 12', 'Paper 13', 'Paper 14', 'Paper 15', 'Paper 16', 'Paper 17', 'Paper 18', 
                  'Paper 19', 'Paper 20', 'Paper 21', 'Paper 22', 'Paper 23', 'Paper 24', 'Paper 25', 'Paper 26', 'Paper 27', 
                  'Paper 28', 'Paper 29', 'Paper 30', 'Paper 31', 'Paper 32', 'Paper 33', 'Paper 34', 'Paper 35', 'Paper 36', 
                  'Paper 37', 'Paper 38', 'Paper 39', 'Paper 40', 'Paper 41', 'Paper 42', 'Paper 43', 'Paper 44', 'Paper 45', 
                  'Paper 46', 'Paper 47', 'Paper 48', 'Paper 49', 'Paper 50', 'Paper 51', 'Paper 52', 'Paper 53', 'Paper 54', 
                  'Paper 55', 'Paper 56', 'Paper 57', 'Paper 58', 'Paper 59', 'Paper 60', 'Paper 61', 'Paper 62', 
                  'Paper 63', 'Paper 64', 'Paper 65', 'Paper 66', 'Paper 67', 'Paper 68', 'Paper 69', 'Paper 70', 'Paper 71', 
                  'Paper 72', 'Paper 73', 'Paper 74', 'Paper 75', 'Paper 76', 'Paper 77'],
         
    },

    xAxis: {
            labels: {
                useHTML: false,
                rotation: 30,
                  style: {
                    color: '#374151',
                    fontSize: '13px',
                    fontWeight: 'normal',
                    fontFamily: 'Montserrat',
                  }
            },
            
        categories: ['COBB',  'Roughness TS',  'Roughness RS',  'Elongation MD',  'Elongation CD',  'Tensile strength MD',  'Tensile strength CD'],
        title: null,
        
    },
    colorAxis: [{
        minColor: '#8bb9a7',
        maxColor: '#ed9071',
        endOnTick: false,
        startOnTick: false,

        showInLegend: false
    },{
        showInLegend: false,
        stops: [
                [0,'#8bb9a7'],
                [0.5,'#eee'],
                [0.9,'#ed9071']
            ],
            min: 0,
        endOnTick: false,
        startOnTick: false
    }],

    tooltip: {
        formatter: function() {
            return '<b>' + this.series.yAxis.categories[this.point.y] + '</b></br><b>' 
            + this.series.xAxis.categories[this.point.x] + '</b>';
        }
    },

    series: [{
        name: 'Not present in TDS/To be evaluated',
        showInLegend: true,
        //borderWidth: 2,
        colorAxis: 1,
        color: '#999',
        data: [
         
         [0, 0, 50], [1, 0, 0], [2, 0, 0], [3, 0, 50], [4, 0, 50], [5, 0, 0], [6, 0, 100], [0, 1, 50], [1, 1, 50], [2, 1, 50], [3, 1, 50], [4, 1, 50], [5, 1, 0], [6, 1, 0], [0, 2, 50], [1, 2, 50], [2, 2, 50], [3, 2, 50], [4, 2, 50], [5, 2, 0], [6, 2, 0], [0, 3, 50], [1, 3, 50], [2, 3, 50], [3, 3, 50], [4, 3, 50], [5, 3, 0], [6, 3, 0], [0, 4, 50], [1, 4, 50], [2, 4, 50], [3, 4, 50], [4, 4, 50], [5, 4, 0], [6, 4, 0], [0, 5, 50], [1, 5, 50], [2, 5, 50], [3, 5, 50], [4, 5, 50], [5, 5, 0], [6, 5, 50], [0, 6, 50], [1, 6, 50], [2, 6, 50], [3, 6, 50], [4, 6, 50], [5, 6, 0], [6, 6, 50], [0, 7, 50], [1, 7, 50], [2, 7, 50], [3, 7, 50], [4, 7, 50], [5, 7, 0], [6, 7, 50], [0, 8, 50], [1, 8, 50], [2, 8, 50], [3, 8, 50], [4, 8, 50], [5, 8, 0], [6, 8, 50], [0, 9, 50], [1, 9, 50], [2, 9, 50], [3, 9, 50], [4, 9, 50], [5, 9, 0], [6, 9, 50], [0, 10, 100], [1, 10, 100], [2, 10, 50], [3, 10, 50], [4, 10, 50], [5, 10, 0], [6, 10, 0], [0, 11, 100], [1, 11, 50], [2, 11, 50], [3, 11, 50], [4, 11, 50], [5, 11, 0], [6, 11, 0], [0, 12, 100], [1, 12, 50], [2, 12, 50], [3, 12, 50], [4, 12, 50], [5, 12, 0], [6, 12, 0], [0, 13, 100], [1, 13, 50], [2, 13, 50], [3, 13, 50], [4, 13, 50], [5, 13, 0], [6, 13, 0], [0, 14, 100], [1, 14, 50], [2, 14, 50], [3, 14, 50], [4, 14, 50], [5, 14, 0], [6, 14, 0], [0, 15, 50], [1, 15, 50], [2, 15, 50], [3, 15, 0], [4, 15, 100], [5, 15, 0], [6, 15, 0], [0, 16, 50], [1, 16, 0], [2, 16, 0], [3, 16, 0], [4, 16, 100], [5, 16, 0], [6, 16, 0], [0, 17, 0], [1, 17, 0], [2, 17, 0], [3, 17, 0], [4, 17, 100], [5, 17, 0], [6, 17, 0], [0, 18, 50], [1, 18, 0], [2, 18, 0], [3, 18, 100], [4, 18, 100], [5, 18, 0], [6, 18, 0], [0, 19, 0], [1, 19, 0], [2, 19, 0], [3, 19, 100], [4, 19, 100], [5, 19, 0], [6, 19, 0], [0, 20, 0], [1, 20, 0], [2, 20, 0], [3, 20, 100], [4, 20, 100], [5, 20, 0], [6, 20, 0], [0, 21, 0], [1, 21, 0], [2, 21, 50], [3, 21, 50], [4, 21, 50], [5, 21, 0], [6, 21, 0], [0, 22, 0], [1, 22, 0], [2, 22, 50], [3, 22, 50], [4, 22, 50], [5, 22, 0], [6, 22, 0], [0, 23, 0], [1, 23, 0], [2, 23, 50], [3, 23, 50], [4, 23, 50], [5, 23, 0], [6, 23, 0], [0, 24, 0], [1, 24, 0], [2, 24, 50], [3, 24, 50], [4, 24, 50], [5, 24, 0], [6, 24, 0], [0, 25, 0], [1, 25, 0], [2, 25, 50], [3, 25, 50], [4, 25, 50], [5, 25, 0], [6, 25, 0], [0, 26, 0], [1, 26, 0], [2, 26, 50], [3, 26, 50], [4, 26, 50], [5, 26, 0], [6, 26, 0], [0, 27, 0], [1, 27, 0], [2, 27, 50], [3, 27, 50], [4, 27, 50], [5, 27, 0], [6, 27, 0], [0, 28, 0], [1, 28, 0], [2, 28, 50], [3, 28, 50], [4, 28, 50], [5, 28, 0], [6, 28, 0], [0, 29, 0], [1, 29, 0], [2, 29, 50], [3, 29, 50], [4, 29, 50], [5, 29, 0], [6, 29, 0], [0, 30, 50], [1, 30, 0], [2, 30, 0], [3, 30, 50], [4, 30, 50], [5, 30, 0], [6, 30, 0], [0, 31, 0], [1, 31, 0], [2, 31, 0], [3, 31, 50], [4, 31, 50], [5, 31, 0], [6, 31, 0], [0, 32, 0], [1, 32, 0], [2, 32, 0], [3, 32, 50], [4, 32, 50], [5, 32, 0], [6, 32, 0], [0, 33, 0], [1, 33, 0], [2, 33, 0], [3, 33, 50], [4, 33, 50], [5, 33, 0], [6, 33, 0], [0, 34, 0], [1, 34, 0], [2, 34, 0], [3, 34, 50], [4, 34, 50], [5, 34, 0], [6, 34, 0], [0, 35, 0], [1, 35, 0], [2, 35, 0], [3, 35, 50], [4, 35, 50], [5, 35, 0], [6, 35, 0], [0, 36, 0], [1, 36, 0], [2, 36, 0], [3, 36, 50], [4, 36, 50], [5, 36, 100], [6, 36, 100], [0, 37, 0], [1, 37, 0], [2, 37, 50], [3, 37, 50], [4, 37, 50], [5, 37, 100], [6, 37, 100], [0, 38, 0], [1, 38, 0], [2, 38, 50], [3, 38, 50], [4, 38, 50], [5, 38, 100], [6, 38, 100], [0, 39, 50], [1, 39, 0], [2, 39, 0], [3, 39, 100], [4, 39, 50], [5, 39, 100], [6, 39, 50], [0, 40, 100], [1, 40, 0], [2, 40, 0], [3, 40, 100], [4, 40, 100], [5, 40, 100], [6, 40, 100], [0, 41, 100], [1, 41, 0], [2, 41, 0], [3, 41, 100], [4, 41, 100], [5, 41, 100], [6, 41, 100], [0, 42, 50], [1, 42, 0], [2, 42, 0], [3, 42, 100], [4, 42, 100], [5, 42, 100], [6, 42, 100], [0, 43, 50], [1, 43, 0], [2, 43, 0], [3, 43, 100], [4, 43, 100], [5, 43, 100], [6, 43, 100], [0, 44, 0], [1, 44, 0], [2, 44, 0], [3, 44, 100], [4, 44, 100], [5, 44, 100], [6, 44, 100], [0, 45, 0], [1, 45, 0], [2, 45, 0], [3, 45, 100], [4, 45, 100], [5, 45, 100], [6, 45, 100], [0, 46, 0], [1, 46, 0], [2, 46, 0], [3, 46, 100], [4, 46, 100], [5, 46, 100], [6, 46, 100], [0, 47, 0], [1, 47, 0], [2, 47, 50], [3, 47, 50], [4, 47, 50], [5, 47, 100], [6, 47, 0], [0, 48, 100], [1, 48, 0], [2, 48, 50], [3, 48, 50], [4, 48, 50], [5, 48, 100], [6, 48, 100], [0, 49, 100], [1, 49, 0], [2, 49, 50], [3, 49, 50], [4, 49, 50], [5, 49, 100], [6, 49, 100], [0, 50, 100], [1, 50, 0], [2, 50, 50], [3, 50, 50], [4, 50, 50], [5, 50, 100], [6, 50, 100], [0, 51, 100], [1, 51, 0], [2, 51, 50], [3, 51, 50], [4, 51, 50], [5, 51, 100], [6, 51, 100], [0, 52, 50], [1, 52, 0], [2, 52, 100], [3, 52, 50], [4, 52, 50], [5, 52, 50], [6, 52, 50], [0, 53, 100], [1, 53, 100], [2, 53, 100], [3, 53, 50], [4, 53, 50], [5, 53, 50], [6, 53, 50], [0, 54, 100], [1, 54, 100], [2, 54, 100], [3, 54, 50], [4, 54, 50], [5, 54, 50], [6, 54, 50], [0, 55, 50], [1, 55, 100], [2, 55, 50], [3, 55, 50], [4, 55, 50], [5, 55, 50], [6, 55, 50], [0, 56, 50], [1, 56, 100], [2, 56, 0], [3, 56, 50], [4, 56, 50], [5, 56, 50], [6, 56, 50], [0, 57, 50], [1, 57, 50], [2, 57, 50], [3, 57, 50], [4, 57, 50], [5, 57, 100], [6, 57, 50], [0, 58, 50], [1, 58, 50], [2, 58, 50], [3, 58, 50], [4, 58, 50], [5, 58, 100], [6, 58, 50], [0, 59, 50], [1, 59, 50], [2, 59, 50], [3, 59, 50], [4, 59, 50], [5, 59, 100], [6, 59, 50], [0, 60, 50], [1, 60, 50], [2, 60, 50], [3, 60, 50], [4, 60, 50], [5, 60, 100], [6, 60, 50], [0, 61, 50], [1, 61, 50], [2, 61, 50], [3, 61, 50], [4, 61, 50], [5, 61, 100], [6, 61, 50], [0, 62, 50], [1, 62, 50], [2, 62, 50], [3, 62, 50], [4, 62, 50], [5, 62, 100], [6, 62, 50], [0, 63, 50], [1, 63, 50], [2, 63, 50], [3, 63, 50], [4, 63, 50], [5, 63, 100], [6, 63, 50], [0, 64, 50], [1, 64, 50], [2, 64, 50], [3, 64, 50], [4, 64, 50], [5, 64, 100], [6, 64, 50], [0, 65, 50], [1, 65, 50], [2, 65, 50], [3, 65, 50], [4, 65, 50], [5, 65, 100], [6, 65, 50], [0, 66, 100], [1, 66, 0], [2, 66, 0], [3, 66, 50], [4, 66, 50], [5, 66, 50], [6, 66, 50], [0, 67, 100], [1, 67, 50], [2, 67, 50], [3, 67, 50], [4, 67, 50], [5, 67, 50], [6, 67, 50], [0, 68, 100], [1, 68, 50], [2, 68, 50], [3, 68, 50], [4, 68, 50], [5, 68, 50], [6, 68, 50], [0, 69, 100], [1, 69, 50], [2, 69, 50], [3, 69, 50], [4, 69, 50], [5, 69, 50], [6, 69, 50], [0, 70, 100], [1, 70, 50], [2, 70, 50], [3, 70, 50], [4, 70, 50], [5, 70, 50], [6, 70, 50], [0, 71, 100], [1, 71, 50], [2, 71, 50], [3, 71, 50], [4, 71, 50], [5, 71, 50], [6, 71, 50], [0, 72, 100], [1, 72, 50], [2, 72, 50], [3, 72, 50], [4, 72, 50], [5, 72, 50], [6, 72, 50], [0, 73, 100], [1, 73, 50], [2, 73, 50], [3, 73, 50], [4, 73, 50], [5, 73, 50], [6, 73, 50], [0, 74, 100], [1, 74, 50], [2, 74, 50], [3, 74, 50], [4, 74, 50], [5, 74, 50], [6, 74, 50]
        ],
        dataLabels: {
            enabled: false
        }
    },{
        name: 'Not available',
        showInLegend: true,
        borderWidth: 2,
        colorAxis: 1,
        color: '#ed9071',
        data: [
            
        ],
        dataLabels: {
            enabled: false
        }
    },{
        name: 'Available',
        showInLegend: true,
        borderWidth: 2,
        colorAxis: 1,
        color: '#8bb9a7',
        data: [
            
        ],
        dataLabels: {
            enabled: false
        }
    },]

}
</script>
<style scoped>
.highcharts-figure,
.highcharts-data-table table {
  /* min-width: 310px;
  max-width: 800px; */
  margin: 1em auto;
}

.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
}

.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}

.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}

.highcharts-data-table tr:hover {
  background: #f1f7ff;
}
</style>